<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card>
      <template slot="no-body">
        <!-- <div class="p-2">
          <vs-switch color="success" v-model="active_geofence">
            <span slot="on">Geofence On </span>
            <span slot="off">Geofence Off </span>
          </vs-switch>
        </div> -->

        <vs-divider style="margin: 0" />
        <vs-row vs-w="12">
          <div class="heights">
            <span></span>
            <l-map v-if="showMap && !isGMap" ref="mapRefLeaflet" :zoom="zoom" :center="center" :options="mapOptions"
              style="height: 100%">
              <l-tile-layer :url="url" :attribution="attribution" />
            </l-map>
            <GmapMap v-else-if="showMap && isGMap" ref="mapRef" :center="center" :zoom="11"
              style="width: 100%; height: 100%" :options="{
                zoom: 15,
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false,
              }">
              <GmapPolygon> </GmapPolygon>
              <gmap-info-window v-if="selectedLocation !== null" :options="{ pixelOffset: { width: 0, height: 0 } }"
                :position="{
                  lat: selectedLocation.latitude,
                  lng: selectedLocation.longitude,
                }" :opened="infoBoxOpen" @closeclick="infoBoxOpen = false">
                <InfoWindow :selectedLocation="selectedLocation" />
              </gmap-info-window>
            </GmapMap>
          </div>
        </vs-row>
      </template>
    </vx-card>
    <vx-card class="absolute w-full h-full justify-center" style="top: 0; left: 0; z-index: 1000"
      v-if="!selectedLocation">
      <div class="flex items-center" style="gap: 10px">
        <div class="loader"></div>
        <p>Waiting for data from vehicle...</p>
      </div>
    </vx-card>

    <!--<vs-button class="mr-3 mb-2" @click="submitForm" >Get Data</vs-button>-->
  </div>
</template>

<script>
import firebase from 'firebase/app'

const car =
  'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
import 'firebase/database'
import * as REPO from '../../repository/index'
import { gmapApi } from 'vue2-google-maps'
import InfoWindow from '../components/InfoWindow.vue'
import { MarkerWithLabel } from '@googlemaps/markerwithlabel'
import BlogNew from '../../assets/images/icons/b_log_new.png'
import { latLng, icon } from 'leaflet'
import 'leaflet-rotatedmarker'

export default {
  components: { InfoWindow },
  data() {
    return {
      monitoringData: {},
      isGMap: null,
      pollingInterval: null,
      color_list: [
        {
          name: 'moving',
          color: '#398d3a',
        },
        {
          name: 'idle',
          color: '#398d3a',
        },
        {
          name: 'stop',
          color: '#398d3a',
        },
        {
          name: 'silence',
          color: '#398d3a',
        },
        {
          name: 'crash',
          color: '#398d3a',
        },
      ],
      // center: { lat: -6.1498619, lng: 106.882887 },
      map: '',
      active_geofence: true,
      // icon: {},
      token: '',
      car: 'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z',
      infoBoxOpen: false,
      selectedLocation: null,

      license_plate: 'Initial License Plate',
      fleet_group_name: 'Initial Fleet Group',

      icon: icon({
        iconUrl: BlogNew,
        iconSize: [56, 56],
        iconAnchor: [28, 35],
      }),
      zoom: 15,
      center: latLng(-6.1498619, 106.882887),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,
    }
  },
  computed: {
    google: gmapApi,
  },
  watch: {
    isGMap: function (val) {
      var self = this
      const data = self.monitoringData
      //
      val = data.map === 'googlemap'
      if (val) {
        setTimeout(() => {
          this.$refs.mapRef.$mapPromise.then((map) => {
            this.map = map
            this.icon = {
              path: this.car,
              scale: 0.7,
              strokeColor: 'white',
              strokeWeight: 0.1,
              fillOpacity: 1,
              fillColor: '#404040',
              offset: '5%',
              // rotation: parseInt(heading[i]),
              anchor: new google.maps.Point(10, 25), // kalau 10,50 belakang, 10,0 depan, 10,25 tengah mobil
            }
            this.initialize(map)
          })
        }, 50)
      } else {
        this.map = this.$refs.mapRefLeaflet.mapObject
        //
      }

      if (data) {
        // Fetch data pertama kali
        self.fetchVehiclePosition()
        
        // Setup polling setiap 4 detik
        self.pollingInterval = setInterval(() => {
          self.fetchVehiclePosition()
        }, 4000)
      } else {
        this.$router.push('/404')
      }
    },
  },
  // created() {
  //   window.onbeforeunload = () => {
  //     //
  //     //
  //     let alamat = this.$route.name
  //     if (alamat == 'monitoringView') {
  //       self.closeHandler()

  //       return 'Some task is in progress. Are you sure, you want to close?'
  //     } else {
  //       return undefined
  //     }
  //   }
  // },
  beforeDestroy() {
    this.navigateHandler()
    // Clear polling interval
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
    }
  },
  methods: {
    fetchVehiclePosition() {
      const self = this
      REPO.getLastPosition(this.token)
        .then((res) => {

          // check token validity
          if(res.data.status !== 'true') {
            // alert(res.data.message || 'Token Expired.')
            this.$toast.error(res.data.message || 'Token Expired.', {
              position: 'top-right',
              duration: 5000,
            })
            return;
          }

          const data = res.data.data
          
          if (this.isGMap) {
            // Google Maps
            // delete self.marker
            if (self.marker) {
              self.marker.setMap(null)
            }
            
            self.selectedLocation = data
            self.center = { lat: data.latitude, lng: data.longitude }
            self.license_plate = data.license_plate
            self.fleet_group_name = data.fleet_group_name

            const markerLabel = () => {
              if (
                self.selectedLocation.license_plate &&
                self.selectedLocation.fleet_group_name
              ) {
                return `<div class="label-nopol" style="background-color: white; text-align: center; position: relative; left: -50%">${self.selectedLocation.license_plate}<br>${self.selectedLocation.fleet_group_name}</div>`
              } else {
                return ''
              }
            }

            self.marker = new MarkerWithLabel({
              icon: self.icon,
              position: self.center,
              map: self.map,
              labelContent: markerLabel(),
              labelAnchor: new google.maps.Point(0, 7),
            })

            const url = BlogNew + '#' + self.selectedLocation.vehicle_id

            const iconMark = {
              url: url,
              anchor: new google.maps.Point(28, 35),
              scaledSize: new google.maps.Size(56, 56),
              labelOrigin: new google.maps.Point(28, 28),
              fillColor: '#00CCBB',
              fillOpacity: 1,
              strokeColor: '',
              strokeWeight: 0,
            }

            self.marker.setPosition(self.center)
            self.marker.setIcon(iconMark)

            const rotateMarker = () => {
              setTimeout(() => {
                const q = document.querySelector(`img[src="${url}"]`)
                if (q) {
                  q.style.cssText += `transform: rotate(${
                    self.selectedLocation.direction + 90
                  }deg); transform-origin: center center;`
                }
              }, 500)
            }
            rotateMarker()
          } else {
            // Leaflet
            self.selectedLocation = data
            self.center = { lat: data.latitude, lng: data.longitude }
            self.license_plate = data.license_plate
            self.fleet_group_name = data.fleet_group_name

            // delete self.marker
            if (self.marker) {
              self.map.removeLayer(self.marker)
            }

            self.marker = L.marker(self.center, {
              rotationAngle: data.direction + 90,
              icon: self.icon,
            })

            self.marker
              .addTo(self.map)
              .bindTooltip(
                `<p class="text-center">${self.license_plate}<br>${self.fleet_group_name || '-'}</p>`,
                {
                  permanent: true,
                  interactive: true,
                  direction: 'bottom',
                }
              )
          }
        })
        .catch((error) => {
          console.error('Error fetching vehicle position:', error)
        })
    },
    navigateHandler() {
      this.reff.off()
      REPO.unsubscribeVehicle(this.id)
    },
    closeHandler(event) {
      this.reff.off()
      REPO.unsubscribeVehicle(this.id)
      return 'oke ?'
    },
    initialize(map) {
      //

      this.infowindow = new google.maps.InfoWindow({
        size: new google.maps.Size(150, 50),
      })
      // Instantiate a directions service.
      this.directionsService = new google.maps.DirectionsService()
      const anim_start = new google.maps.LatLng(
        this.center.lat,
        this.center.lng
      )
      map.setCenter(anim_start)

      //

      // const markerLabel = () => {
      //   if (
      //     selectedLocation.license_plate &&
      //     selectedLocation.fleet_group_name
      //   ) {
      //     return `<div class="label-nopol" style="background-color: white; text-align: center; position: relative; left: -50%">${selectedLocation.license_plate}<br>${selectedLocation.fleet_group_name}</div>`
      //   } else {
      //     //
      //     return ''
      //   }
      // }

      // this.marker = new MarkerWithLabel({
      //   // position: this.polyline.getPath().getAt(0),
      //   icon: this.icon,
      //   position: anim_start,
      //   map: this.map,
      //   labelContent: markerLabel(),
      //   labelAnchor: new google.maps.Point(0, 7),
      // })
    },
  },
  beforeMount() {
    const self = this
    this.token = this.$route.params.token
    REPO.getLiveMonitoring(this.token).then((res) => {
      const data = res.data.data
      self.monitoringData = data
      self.isGMap = data.map === 'googlemap'
      //
    })
  },
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style lang="scss">
.heights {
  width: 100%;
  height: calc(100vh - 1px);
  // height: calc(100vh - 15.1rem);
}

.loader {
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 25px;
  height: 25px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}
</style>
